import {Alert} from "@material-ui/lab";
import styles from "./ErrorAlert.module.scss"

const ErrorAlert = ({children}) => (
    <Alert severity="warning" className={styles.alert} >{children}</Alert>
)

export default ErrorAlert